import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAppContext } from '../context/AppContext';
import { toast } from 'react-hot-toast';

/**
 * AdminRoute Component
 * 
 * Protects routes that require admin access.
 * Redirects non-admin users to the home page.
 */
const AdminRoute = ({ children }) => {
  const { isAdmin } = useAppContext();
  
  // Check if user is admin
  if (!isAdmin) {
    toast.error('Access denied. Admin privileges required.');
    return <Navigate to="/" replace />;
  }
  
  return children;
};

export default AdminRoute;

